import React from 'react';
import { Text, TextAs, TextSizes } from '@clockout-dev/design-elements';
import ProductOrStateRulesPanel from '../../productOrStateRules/ProductOrStateRulesPanel';
import styles from '../styles/feeStructureForm.module.scss';

function ProductTypesPanel({ rules = [], options, onAdd, onRemove, onUpdate }) {
    return (
        <ProductOrStateRulesPanel
            rules={rules}
            matchKey="productType"
            options={options}
            prefix="if the product is"
            valueLabel="the advance fee is"
            valueKey="fee"
            inputProps={{
                prefix: <Text as={TextAs.SPAN} size={TextSizes.SMALL}>$</Text>,
                min: 0,
                max: 999.99,
                step: 0.01,
                precision: 2
            }}
            onAdd={onAdd}
            onRemove={onRemove}
            onUpdate={onUpdate}
            addLabel="Add a product type row"
            emptyTitle="No product type rules yet"
            emptyDescription="Add a row to set a custom advance fee for a product type."
            classNames={{
                row: styles.ruleRow,
                label: styles.ruleLabel,
                select: `${styles.select} ${styles.selectMd}`,
                input: `${styles.inlineNumberInput} ${styles.amountField}`
            }}
        />
    );
}

export default ProductTypesPanel;
